<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <translation_table :words="content" />
        </div>

        <pagination :allData="translationData" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import translation_table from '@/components/application/localization/translation/translation_table.vue';
import pagination from '@/layouts/elements/pagination.vue';
import { useFunctionalitiesStore } from '@/store/functionalities';
import { useTranslationStore } from '@/store/translation';
import { storeToRefs } from 'pinia';

const functionalitiesStore = useFunctionalitiesStore();
const { state } = storeToRefs(functionalitiesStore);
const translationStore = useTranslationStore();
const { data } = storeToRefs(translationStore);

const translationData = computed(() => data.value);
const content = computed(() => state.value.content);
</script>

<style></style>
